export default __webpack_public_path__ + "static/media/GreiffModernSf.e690990d.jpg";